// src/components/session/CookieConsentDialog.js
import React from "react";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, List, ListItem, ListItemIcon,
  ListItemText, Typography,
} from "@mui/material";
import CookieOutlinedIcon from "@mui/icons-material/CookieOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { COOKIE_NOTICE } from "../../content/guide";

/** Blocking notice shown before the session cookie is created. */
export default function CookieConsentDialog({ open, declined, onAccept, onDecline, onReview }) {
  if (declined) {
    return (
      <Dialog open={open} maxWidth="sm" fullWidth aria-labelledby="consent-declined-title">
        <DialogTitle id="consent-declined-title">The tool needs this one cookie</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Without it we cannot save your answers between steps, so the tool cannot be used.
            Nothing has been stored.
          </Typography>
          <Typography variant="body2">
            You can still read <Link href="/guide/">how the tool works</Link> and our{" "}
            <Link href="/privacy/" target="_blank" rel="noopener">privacy notice</Link>.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button variant="contained" onClick={onReview} autoFocus>Review the notice again</Button>
        </DialogActions>
      </Dialog>
    );
  }
  return (
    <Dialog open={open} maxWidth="sm" fullWidth aria-labelledby="consent-title" disableEscapeKeyDown>
      <DialogTitle id="consent-title" sx={{ display: "flex", alignItems: "center", gap: 1.5, fontWeight: 700 }}>
        <CookieOutlinedIcon /> {COOKIE_NOTICE.title}
      </DialogTitle>
      <DialogContent>
        <List dense disablePadding>
          {COOKIE_NOTICE.points.map((p) => (
            <ListItem key={p} disableGutters alignItems="flex-start">
              <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="small" color="success" />
              </ListItemIcon>
              <ListItemText primary={p} primaryTypographyProps={{ variant: "body2" }} />
            </ListItem>
          ))}
        </List>
        <Box sx={{ mt: 1 }}>
          <Link href="/privacy/" target="_blank" rel="noopener" variant="body2">
            Read the full privacy and cookie notice
          </Link>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1, flexWrap: "wrap" }}>
        <Button onClick={onDecline} color="inherit">No thanks</Button>
        <Button variant="contained" onClick={onAccept} autoFocus>Accept and continue</Button>
      </DialogActions>
    </Dialog>
  );
}
